import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback, errorCallback = null) => {
    return AppModel.post('login', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['login'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, errorCallback, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('login', 'login', key)
  },
  removeStore: () => {
    delete store.getters.model.login
  }
}



// WEBPACK FOOTER //
// ./src/models/LoginModel.js